import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    rootAppAlert: {
        '& .bot-acts': {
            width: '100%',
            padding: 10,
            display: 'flex',
            justifyContent: 'space-between',
        },
    },
}));
